/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for an email recipient
 * @export
 * @interface EmailRecipientInput
 */
export interface EmailRecipientInput {
    /**
     * Recipient email address
     * @type {string}
     * @memberof EmailRecipientInput
     */
    email: string;
    /**
     * Recipient display name
     * @type {string}
     * @memberof EmailRecipientInput
     */
    name?: string;
}

/**
 * Check if a given object implements the EmailRecipientInput interface.
 */
export function instanceOfEmailRecipientInput(value: object): value is EmailRecipientInput {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function EmailRecipientInputFromJSON(json: any): EmailRecipientInput {
    return EmailRecipientInputFromJSONTyped(json, false);
}

export function EmailRecipientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailRecipientInput {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EmailRecipientInputToJSON(json: any): EmailRecipientInput {
    return EmailRecipientInputToJSONTyped(json, false);
}

export function EmailRecipientInputToJSONTyped(value?: EmailRecipientInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
    };
}

